import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Constants } from '../../_utility';
import { BreadcrumbsService } from '../../_components/breadcrumbs/breadcrumbs.service';
import { AuthService } from '../../_services';
import { Roles } from '../../_models';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [TranslateModule],
})
export class HomeComponent {
  constructor(
    private router: Router,
    private auth: AuthService,
    private breadcrumb: BreadcrumbsService
  ) {}
  ngOnInit() {
    setTimeout(() => {
      this.breadcrumb.setCrumbs(Constants.Routing.HOME.path);
    }, 200);
  }
  isRestrictedOperator(): boolean {
    const roles = this.auth.roles;
    return roles.includes(Roles.OPERATORE);
  }
  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate(Constants.Routing.HOME.routerLink);
        break;
      }
      case 'ristoranti': {
        this.router.navigate(Constants.Routing.HOME_RISTORANTI.routerLink);
        break;
      }
      case 'prenotazioni': {
        this.router.navigate(Constants.Routing.HOME_PRENOTAZIONI.routerLink);
        break;
      }
    }
  }
}
